/**
 * Authentication Store Plugin
 *
 * Intercepts authentication actions to:
 * - Prevent duplicate notifications for enhanced authentication errors
 * - Show logout confirmation dialog before logout
 */

const authenticationPlugin = (store) => {
  // Store original dispatch method
  const originalDispatch = store.dispatch

  // Override dispatch to intercept authentication actions
  store.dispatch = function(type, payload, options) {
    // Intercept AUTHENTICATION_ERROR and AUTHENTICATION_WARNING actions
    if (type === 'authentication/ERROR' || type === 'authentication/WARNING') {
      // Check if this is an enhanced error that should skip UI notifications
      if (payload && payload.skipUINotification) {
        // Skip the UI library notification by not calling the original dispatch
        return Promise.resolve()
      }
    }

    // Intercept LOGOUT action to show confirmation dialog
    if (type === 'LOGOUT') {
      // Check if this is a confirmed logout (bypass confirmation)
      if (payload && payload.confirmed) {
        // Remove the confirmed flag and proceed with original logout
        const cleanPayload = { ...payload }
        delete cleanPayload.confirmed
        return originalDispatch.call(this, type, cleanPayload, options)
      }

      // Show logout confirmation dialog using proper Vuex action
      originalDispatch.call(this, 'showLogoutConfirmation')

      // Return a resolved promise to maintain API consistency
      return Promise.resolve()
    }

    // For all other actions, call the original dispatch
    return originalDispatch.call(this, type, payload, options)
  }
}

export default authenticationPlugin
